import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = ["src"]

import { computed, ref } from "vue";
import dayjs, { Dayjs } from "dayjs";
import { useRoute } from "vue-router";
import { useQuery } from "@vue/apollo-composable";
import { GET_PROJECT_DASHBOARD_URL } from "@/graphql/project/queries";
import MonthPicker from "@/components/MonthPicker.vue";
import { useI18n } from "vue-i18n";
import enUK from "@/locales/project/en-UK.json";
import { AoTabBar } from "@26lights/orcha";

type MessageSchema = typeof enUK;

interface Project {
  id: string;
  name: string;
  dashboardUrl: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectExternalDashboard',
  setup(__props) {

const route = useRoute();

const { t } = useI18n<[MessageSchema], "en-UK">({
  useScope: "global",
  inheritLocale: true,
  messages: {
    "en-UK": enUK,
  },
});

const selectedTab = ref<"global" | "yearly" | "monthly">("monthly");

const tabs = [
  { label: "Global", value: "global" },
  { label: "Yearly", value: "yearly" },
  { label: "Monthly", value: "monthly" },
];

// MONTH
const defaultMonth = dayjs(new Date()).subtract(1, "M");
const selectedMonth = ref<Dayjs | null>(defaultMonth);
const selectedMonthName = computed(
  () =>
    selectedMonth?.value?.format("MMMM YYYY") ??
    t("project.dashboard.month.global"),
);
const month = computed(() =>
  selectedTab.value === "monthly"
    ? selectedMonth.value?.format("YYYY-MM-DD") ?? null
    : null,
);
const setPrevMonth = () => {
  selectedMonth.value = selectedMonth.value?.subtract(1, "M") ?? defaultMonth;
};
const setNextMonth = () => {
  selectedMonth.value = selectedMonth.value?.add(1, "M") ?? defaultMonth;
};

// YEAR
const defaultYear = dayjs(); // current year
const selectedYear = ref<Dayjs | null>(defaultYear);
const year = computed(() =>
  selectedTab.value === "yearly"
    ? selectedYear.value?.format("YYYY-MM-DD") ?? null
    : null,
);
const formattedYear = computed(() => selectedYear?.value?.format("YYYY"));

const setPrevYear = () => {
  selectedYear.value = selectedYear.value?.subtract(1, "year") ?? defaultYear;
};
const setNextYear = () => {
  selectedYear.value = selectedYear.value?.add(1, "year") ?? defaultYear;
};

const projectId = computed(() => {
  return typeof route.params.id === "string"
    ? route.params.id
    : route.params.id[0];
});

const variables = computed(() => ({
  id: projectId.value,
  month: month.value,
  year: year.value,
}));

const { result } = useQuery<{ project: Project }>(
  GET_PROJECT_DASHBOARD_URL,
  variables,
);

const src = computed(() => result.value?.project.dashboardUrl);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(AoTabBar), {
        modelValue: selectedTab.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedTab).value = $event)),
        tabs: tabs
      }, null, 8, ["modelValue"]),
      (selectedTab.value === 'monthly')
        ? (_openBlock(), _createBlock(MonthPicker, {
            key: 0,
            label: selectedMonthName.value,
            onPrev: setPrevMonth,
            onNext: setNextMonth
          }, null, 8, ["label"]))
        : _createCommentVNode("", true),
      (selectedTab.value === 'yearly')
        ? (_openBlock(), _createBlock(MonthPicker, {
            key: 1,
            label: formattedYear.value,
            onPrev: setPrevYear,
            onNext: setNextYear
          }, null, 8, ["label"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("iframe", {
      class: "metabase-dashboard",
      src: src.value
    }, null, 8, _hoisted_3)
  ]))
}
}

})